import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicSite from "./pages/PublicSite";
import CancelPage from "./pages/CancelPage";
import ReschedulePage from "./pages/ReschedulePage";
import ProposalPage from "./pages/ProposalPage";
import OfferPage from "./pages/OfferPage";
import NewsPage from "./pages/NewsPage";
import ReviewsPage from "./pages/ReviewsPage";
import AgendaOverviewPage from "./pages/AgendaOverviewPage";
import Login from "./pages/admin/Login";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Customers from "./pages/admin/Customers";
import CalendarPage from "./pages/admin/CalendarPage";
import OpeningHours from "./pages/admin/OpeningHours";
import Requests from "./pages/admin/Requests";
import Settings from "./pages/admin/Settings";
import Treatments from "./pages/admin/Treatments";
import Reviews from "./pages/admin/Reviews";
import Campaigns from "./pages/admin/Campaigns";
import Gallery from "./pages/admin/Gallery";
import Financial from "./pages/admin/Financial";
import ChatAdmin from "./pages/admin/ChatAdmin";
import Todos from "./pages/admin/Todos";
import LoadReport from "./pages/admin/LoadReport";
import PlannerLayout from "./pages/planner/PlannerLayout";
import PlannerLogin from "./pages/planner/PlannerLogin";
import TodayPlanner from "./pages/planner/TodayPlanner";

function BeheerRedirect() {
  const loc = useLocation();
  const rest = loc.pathname.replace(/^\/beheer/, "");
  return <Navigate to={`/admin${rest}${loc.search}`} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicSite />} />
            <Route path="/annuleren/:token" element={<CancelPage />} />
            <Route path="/verzetten/:token" element={<ReschedulePage />} />
            <Route path="/voorstel/:token" element={<ProposalPage />} />
            <Route path="/aanbod/:token" element={<OfferPage />} />
            <Route path="/nieuws/:id" element={<NewsPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/agenda-overzicht/:token" element={<AgendaOverviewPage />} />
            <Route path="/admin/login" element={<PlannerLogin redirectTo="/admin" appName="Beheer" subtitle="Beheer & agenda" />} />
            <Route path="/beheer/*" element={<BeheerRedirect />} />
            <Route path="/planner/login" element={<PlannerLogin />} />
            <Route path="/planner" element={<ProtectedRoute loginPath="/planner/login"><PlannerLayout /></ProtectedRoute>}>
              <Route index element={<TodayPlanner />} />
              <Route path="agenda" element={<CalendarPage />} />
              <Route path="todos" element={<Todos />} />
            </Route>
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="agenda" element={<CalendarPage />} />
              <Route path="todos" element={<Todos />} />
              <Route path="behandelingen" element={<Treatments />} />
              <Route path="reviews" element={<Reviews />} />
              <Route path="galerij" element={<Gallery />} />
              <Route path="openingstijden" element={<OpeningHours />} />
              <Route path="klanten" element={<Customers />} />
              <Route path="aanvragen" element={<Requests />} />
              <Route path="campagnes" element={<Campaigns />} />
              <Route path="financieel" element={<Financial />} />
              <Route path="rapport" element={<LoadReport />} />
              <Route path="chat" element={<ChatAdmin />} />
              <Route path="instellingen" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
